'use strict';
var parent = require('../../es/object/define-properties');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/stable/object/define-properties.js
// module id = 773
// module chunks = 13